<template>
  <footer>
    <section class="footer">
      <div class="row footer__container container">
        <section class="footer__column col-sm-4">
          <app-logo class="logo" />
        </section>

        <section
          class="footer__column col-sm-4"
          v-if="column_2"
        >
          <h3
            class="title--h3 color--white"
            v-if="translate(column_2.title)"
          >
            {{ translate(column_2.title) }}
          </h3>

          <ul
            :class="{ 'margin__t--12': column_2.title }"
            v-if="navigation.length"
          >
            <li
              class="footer__li"
              v-for="({ link }, index) in navigation"
              :key="'footer_navigation_item_' + index"
            >
              <app-link
                :link="link"
                class="footer__link"
                v-slot="{ text }"
              >
                <fa-icon
                  class="margin__r--6"
                  v-if="link.icon"
                  :icon="link.icon"
                />

                {{ text }}
              </app-link>
            </li>
          </ul>
        </section>

        <section
          class="footer__column col-sm-4"
          v-if="column_3"
        >
          <h3
            class="title--h3 color--white"
            v-if="translate(column_3.title)"
          >
            {{ translate(column_3.title) }}
          </h3>

          <ul
            :class="{ 'margin__t--12': column_3.title }"
            v-if="actions.length"
          >
            <li
              class="footer__li"
              v-for="({ link }, index) in actions"
              :key="'footer_actions_item_' + index"
            >
              <app-link
                :link="link"
                class="footer__link"
                v-slot="{ text }"
              >
                <fa-icon
                  class="margin__r--6"
                  v-if="link.icon"
                  :icon="link.icon"
                />

                {{ text }}
              </app-link>
            </li>
          </ul>
        </section>
      </div>
    </section>
  </footer>
</template>

<script setup>
import { useI18n } from '@/vendors/i18n'

import AppLogo from '&/atoms/AppLogo'
import AppLink from '&/atoms/AppLink'

const { section } = defineProps({
  section: {
    required: true,
    type: Object
  }
})

const { translate } = useI18n()

const { column_2, column_3 } = section.attributes
const { navigation = [] } = column_2
const { actions = [] } = column_3
</script>

<style lang="scss" scoped>
:deep() {
  .footer__link {
    color: $white;
    font-size: rem(20px);
    margin: 5px 0 5px 0;
    display: inline-block;
    position: relative;

    @include mq(md) {
      font-size: rem(24px);
      margin: 5px 0 10px 0;
    }

    &:after {
      content: "";
      display: block;
      position: absolute;
      transition: width 0.3s;
      width: 45px;
      height: 3px;
      bottom: 0;
      left: 0;
      background: $color--primary;
    }

    &:focus,
    &:hover {
      &:after {
        width: 100%;
      }
    }

    &--active {
      color: $color--primary;

      &:after {
        width: 100%;
      }
    }
  }

  .logo {
    max-width: 215px;
  }

  @media only screen and (max-width: 767px) {
    .logo {
      margin: auto;
    }
  }
}

.footer {
  background-color: #000000;

  &__container {
    display: flex;
    align-items: flex-start;
    padding: $padding--base * 2 0;
  }

  &__column {
    width: 100%;
    margin: 12px 0;
    text-align: center;

    @include mq(sm) {
      width: 50%;
      text-align: left;
      margin: 24px 0;
    }

    @include mq(md) {
      margin: 0;
    }
  }
}

.title {
  &--h3 {
    font-size: rem(24px);
    margin-bottom: 24px;
    position: relative;
    display: inline-block;
  }
}

.footer__container {
  margin: auto;
}
</style>
